import { useTranslation } from 'react-i18next';

export default function SafuFund() {
  const { t } = useTranslation();
  const features = [
    { icon: 'ri-links-line', titleKey: 'safuFund.f0_title', descKey: 'safuFund.f0_desc' },
    { icon: 'ri-eye-line', titleKey: 'safuFund.f1_title', descKey: 'safuFund.f1_desc' },
    { icon: 'ri-time-line', titleKey: 'safuFund.f2_title', descKey: 'safuFund.f2_desc' },
    { icon: 'ri-file-search-line', titleKey: 'safuFund.f3_title', descKey: 'safuFund.f3_desc' },
  ];
  const stats = [
    { labelKey: 'safuFund.stat0_label', value: '$10M', subKey: 'safuFund.stat0_sub' },
    { labelKey: 'safuFund.stat1_label', value: '100%', subKey: 'safuFund.stat1_sub' },
    { labelKey: 'safuFund.stat2_label', value: '24/7', subKey: 'safuFund.stat2_sub' },
    { labelKey: 'safuFund.stat3_label', value: t('safuFund.stat3_val'), subKey: 'safuFund.stat3_sub' },
  ];
  return (
    <section className="py-20 md:py-28 relative overflow-hidden" style={{ background: 'linear-gradient(180deg, #0c0814 0%, #080f10 50%, #0c0814 100%)' }}>
      <div className="absolute inset-0 grid-bg pointer-events-none opacity-40" />
      <div className="absolute inset-0 pointer-events-none" style={{ backgroundImage: 'radial-gradient(ellipse at 50% 40%, rgba(52,211,153,0.07) 0%, transparent 65%)' }} />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full border border-emerald-400/5 pointer-events-none" />
      <div className="max-w-6xl mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 border border-emerald-400/30 bg-emerald-400/8 text-emerald-400 text-xs font-bold tracking-widest uppercase px-4 py-1.5 rounded-full mb-6">
            <i className="ri-shield-check-fill text-sm"></i>
            {t('safuFund.badge')}
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-white font-display leading-none mb-4" style={{ letterSpacing: '-0.03em' }}>
            Polywin&nbsp;
            <span style={{ backgroundImage: 'linear-gradient(90deg,#34d399,#10b981)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
              {t('safuFund.titleHighlight')}
            </span>
          </h2>
          <p className="text-white/40 text-base md:text-lg max-w-xl mx-auto">{t('safuFund.desc')}</p>
        </div>
        <div className="relative rounded-3xl overflow-hidden mb-6 border border-emerald-400/20"
          style={{ background: 'linear-gradient(135deg, rgba(10,40,34,0.7) 0%, rgba(5,24,20,0.85) 50%, rgba(10,40,34,0.7) 100%)' }}>
          <div className="absolute top-0 left-0 right-0 h-px" style={{ background: 'linear-gradient(90deg, transparent, rgba(52,211,153,0.6), transparent)' }} />
          <div className="relative z-10 px-6 py-10 md:px-14 md:py-14">
            <div className="flex flex-col md:flex-row items-center gap-10 md:gap-14">
              <div className="flex-shrink-0 relative">
                <div className="w-28 h-28 md:w-36 md:h-36 rounded-full flex items-center justify-center relative"
                  style={{ background: 'radial-gradient(circle, rgba(52,211,153,0.15) 0%, rgba(10,40,34,0.6) 100%)', border: '1px solid rgba(52,211,153,0.25)', boxShadow: '0 0 60px rgba(52,211,153,0.15)' }}>
                  <i className="ri-shield-check-fill text-6xl md:text-7xl text-emerald-400"></i>
                </div>
                <div className="absolute inset-0 rounded-full border border-emerald-400/15 animate-ping" style={{ animationDuration: '3s' }} />
                <div className="absolute -bottom-1 -right-1 w-9 h-9 rounded-full flex items-center justify-center"
                  style={{ background: 'linear-gradient(135deg,#10b981,#059669)', boxShadow: '0 0 12px rgba(52,211,153,0.4)' }}>
                  <i className="ri-check-line text-white text-base font-black"></i>
                </div>
              </div>
              <div className="flex-1 text-center md:text-left">
                <div className="text-emerald-400/60 text-xs font-mono uppercase tracking-widest mb-3">{t('safuFund.reserveLabel')}</div>
                <div className="flex flex-col md:flex-row md:items-end gap-3 md:gap-5 justify-center md:justify-start mb-5">
                  <span className="text-5xl md:text-7xl font-black leading-none tracking-tight"
                    style={{ backgroundImage: 'linear-gradient(135deg,#34d399,#10b981)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                    $10,000,000
                  </span>
                  <div className="inline-flex items-center gap-1.5 bg-emerald-400/12 border border-emerald-400/30 text-emerald-300 text-xs font-bold px-3 py-1.5 rounded-full self-center md:self-end mb-1 whitespace-nowrap">
                    <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse inline-block"></span>
                    {t('safuFund.verified')}
                  </div>
                </div>
                <p className="text-white/45 text-sm md:text-base leading-relaxed max-w-2xl">{t('safuFund.mainDesc')}</p>
              </div>
              <div className="flex-shrink-0 grid grid-cols-2 md:grid-cols-1 gap-3 w-full md:w-36">
                {stats.slice(0, 2).map(s => (
                  <div key={s.labelKey} className="rounded-xl px-4 py-3.5 text-center border border-emerald-400/15" style={{ background: 'rgba(52,211,153,0.06)' }}>
                    <div className="text-xl font-extrabold text-emerald-300 font-heading leading-none mb-1">{s.value}</div>
                    <div className="text-xs text-emerald-400/60">{t(s.subKey)}</div>
                    <div className="text-xs text-white/30 mt-0.5">{t(s.labelKey)}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="border-t border-emerald-400/12 px-6 py-4 md:px-14 flex flex-col sm:flex-row items-start sm:items-center gap-3" style={{ background: 'rgba(52,211,153,0.03)' }}>
            <div className="flex items-center gap-2 flex-shrink-0">
              <i className="ri-ethereum-line text-base text-emerald-400"></i>
              <span className="text-xs font-bold text-emerald-400 uppercase tracking-wider">{t('safuFund.contractLabel')}</span>
            </div>
            <a href="https://etherscan.io/address/0xc0072b251d141d3b335a74b3680829a04436fa7e#tokentxns" target="_blank" rel="nofollow noopener noreferrer" className="text-xs text-emerald-400/50 hover:text-emerald-400 font-mono break-all transition-colors cursor-pointer">
              0xc0072b251d141d3b335a74b3680829a04436fa7e
            </a>
            <a href="https://etherscan.io/address/0xc0072b251d141d3b335a74b3680829a04436fa7e#tokentxns" target="_blank" rel="nofollow noopener noreferrer" className="flex-shrink-0 sm:ml-auto inline-flex items-center gap-1.5 bg-emerald-400/12 hover:bg-emerald-400/22 border border-emerald-400/25 text-emerald-400 text-xs font-bold px-4 py-2 rounded-lg transition-all cursor-pointer whitespace-nowrap">
              <i className="ri-external-link-line text-sm"></i>
              {t('safuFund.etherscanBtn')}
            </a>
          </div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
          {stats.map((s, i) => (
            <div key={i} className="rounded-2xl px-5 py-5 text-center border border-emerald-400/12 transition-all duration-300 hover:border-emerald-400/25" style={{ background: 'rgba(52,211,153,0.04)' }}>
              <div className="text-2xl md:text-3xl font-black text-emerald-300 font-heading leading-none mb-1">{s.value}</div>
              <div className="text-xs text-emerald-400/60 font-mono mb-0.5">{t(s.subKey)}</div>
              <div className="text-xs text-white/30">{t(s.labelKey)}</div>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {features.map((f, i) => (
            <div key={i} className="group flex items-start gap-5 rounded-2xl px-6 py-6 border border-white/6 transition-all duration-300 hover:border-emerald-400/20" style={{ background: 'rgba(255,255,255,0.025)' }}
              onMouseEnter={e => { (e.currentTarget as HTMLDivElement).style.background = 'rgba(52,211,153,0.05)'; }}
              onMouseLeave={e => { (e.currentTarget as HTMLDivElement).style.background = 'rgba(255,255,255,0.025)'; }}>
              <div className="flex-shrink-0 w-12 h-12 rounded-xl flex items-center justify-center border border-emerald-400/20 transition-all duration-300 group-hover:border-emerald-400/40" style={{ background: 'rgba(52,211,153,0.08)' }}>
                <i className={`${f.icon} text-xl text-emerald-400`}></i>
              </div>
              <div>
                <h4 className="text-base font-bold text-white mb-1.5 font-heading">{t(f.titleKey)}</h4>
                <p className="text-sm text-white/40 leading-relaxed">{t(f.descKey)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
